<div
  *ngIf="isLoading"
  class="global-loader">
  <div class="global-loader__content">
    <img
      src="assets/img/spinner.svg"
      alt="Spinner"
      class="global-loader__content-img" />
    <p class="global-loader__content-description">
      {{ "SPINNER.DESCRIPTION" | translate }}
      <span
        loadingDots
        class="dots"></span>
    </p>
  </div>
</div>
